import React from "react";
import { useHistory, useLocation } from "react-router";
import Card from "../CommonComponents/Card";
import HeadLines from "../CommonComponents/HeadLines";
import OptionItem from "../Profile/OptionItem";
import { optionsData } from "./constant";
import style from "./style.module.css";
import { eventTracker } from "../GATracker3.0/eventTracker";
import {
  BOOK_WAREHOUSE_BANNER_CLICKED,
  POST_TRADE_REQUIREMENT_CLICKED,
  QUICK_LINK_CLICKED,
} from "../GATracker3.0/constants";
import { isMobile } from "../helperFunc";
import useUserDetails from "../CustomHooks/useUserDetails";

const OptionsComponent = (props) => {
  let data = props.optionsDataArray || optionsData;

  const userDetails = useUserDetails();

  const blockLead = userDetails?.id === 11455 || userDetails?.arya_id === 6983;

  const history = useHistory();
  const location = useLocation();
  return (
    <Card
      className={`backgroundWhite d-flex 
                    padding-top16
                    
                    
                    ${
                      isMobile
                        ? "flex-wrap boxRadius8 padding-left12 padding-right12 margin16"
                        : `lightBorder width-fit-content gap30 justify-content-center top-bottom-margin-40 ${style["border-radius42"]} ${style["marginLeftRight107"]} ${style["padding-left-right36"]} ${style["maxWidth1225"]}`
                    }
                    
                    ${style["boxShadow1"]} padding-bottom16
                    ${props.optionsDataArray ? "" : "padding-bottom8"}
                   `}
    >
      {data.map((el) => {
        if (blockLead && el.text === "A/C Statement") {
          return <></>;
        }
        return (
          <OptionItem
            iconClassName={
              isMobile ? style["height-width24"] : style["height-width32"]
            }
            onClick={() => {
              eventTracker("event", QUICK_LINK_CLICKED, {
                addinfo: el.text,
              });

              if (el.text === "Post Trade") {
                eventTracker("event", POST_TRADE_REQUIREMENT_CLICKED, {
                  pagename:
                    location.pathname === "/" ? "homepage" : location.pathname,
                  addinfo: "CTA",
                });
              }
              if (el.text === "Find Warehouse") {
                eventTracker("event", BOOK_WAREHOUSE_BANNER_CLICKED, {
                  pagename:
                    location.pathname === "/" ? "homepage" : location.pathname,
                });
              }
              history.push(el.link);
            }}
            icon={el.icon}
            className={
              isMobile ? `${style["flex25"]} padding-top8` : ` cursorPointer`
            }
            text={
              <HeadLines
                className={`
                  ${
                    isMobile
                      ? `font-size10 line-height12 letterSpacing004`
                      : `font-size16 line-height19 letterSpacing001  grayDark`
                  }
                  grayDark text-center
                 `}
                text={el.text}
              />
            }
          />
        );
      })}
    </Card>
  );
};
export default OptionsComponent;
